import React, { useEffect, useState } from 'react';
import { Attachments, MarkupElement } from 'src/functions/formatElement.htmlAst';
import { StyledComponent } from 'styled-components';
import { ArticleBodyWithTableOfContentsContainer } from './ArticleBodyWithTableOfContents.styles';
import FixedTableOfContents from 'app_previous/organisms/Shared/Articles/FixedTableOfContents/FixedTableOfContents';
import { useArticleTableOfContents } from 'src/hooks/useArticleTableOfContents';
import { getTableOfContentDictionary } from 'src/functions/getTableOfContentDictionary';
import ArticleBody from './ArticleBody';

interface ArticleBodyWithTableOfContentsContainerProps {
  hasTableOfContents?: boolean;
  contentHtmlAst: MarkupElement[];
  contentTemplateContainer?: StyledComponent<'div', any, Record<string, unknown>, never>;
  contentId?: string;
  contentDataSectionName?: string;
  pathPrefix?: string;
  articleData: {
    slug: string;
    title: string;
    attachments: Attachments;
  };
  attachedElement?: () => JSX.Element;
}

const ArticleBodyWithTableOfContents = ({
  hasTableOfContents,
  contentTemplateContainer,
  contentHtmlAst,
  articleData,
  contentDataSectionName,
  contentId,
  pathPrefix,
  attachedElement,
}: ArticleBodyWithTableOfContentsContainerProps): JSX.Element => {
  const [loadingTableOfContents, setLoadingTableOfContents] = useState(true);

  const { setTableOfContentsConfig, tocData } = useArticleTableOfContents();

  useEffect(() => {
    if (!hasTableOfContents) return;

    const tocData = getTableOfContentDictionary(contentHtmlAst);

    const MobileTableOfContents = () => (
      <FixedTableOfContents
        articleData={articleData}
        tocData={tocData}
        isSticky={false}
      />
    );

    setTableOfContentsConfig({
      tocData,
      hideOnDesktop: true,
      customizableComponent: MobileTableOfContents,
    });

    setLoadingTableOfContents(false);
  }, [articleData, setTableOfContentsConfig]);

  return (
    <ArticleBodyWithTableOfContentsContainer
      hasTableOfContents={hasTableOfContents}
      className='article-body-with-toc-container'
    >
      {hasTableOfContents && (
        <FixedTableOfContents
          isLoading={loadingTableOfContents}
          articleData={articleData}
          tocData={tocData}
          pathPrefix={pathPrefix}
          isSticky
          className='sticky-toc'
          attachedElement={attachedElement}
        />
      )}

      <ArticleBody
        contentHtmlAst={contentHtmlAst}
        articleData={articleData}
        contentId={contentId}
        contentDataSectionName={contentDataSectionName}
        contentTemplateContainer={contentTemplateContainer}
      />
    </ArticleBodyWithTableOfContentsContainer>
  );
};

export default ArticleBodyWithTableOfContents;
